import React from "react";

const Counter = ({ value, brand, alert }) => {
  const classes = ["gl-notification__count gl-very-small-text navbar-campaign-link-icon-reverse font-bold"];
  if (brand) classes.push("brand");
  if (alert) classes.push("alert");
  const className = classes.join(" ");


  return (
    <span
      id="notification-counter"
      className={className}
    >
      {value}
    </span>
  );
};

export default Counter;
